export default [
  {
    name: 'news',//帮助中心
    path: '/news',
    meta: {
      title: '帮助中心',
      showTab: true,
      goHome: true,
    },
    component: () => import("@/pages/news/news.vue")
  },
  {
    name: 'newsDetail',//帮助详情
    path: '/newsDetail',
    meta: {
      title: '帮助详情',
      showTab: false,
      goHome: true,
    },
    component: () => import("@/pages/news/newsDetail.vue"),
  },
]